import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { RouterModule } from "@angular/router";
import { InlineSVGModule } from "ng-inline-svg-2";
import { FormsModule } from "@angular/forms";
import { AgGridModule } from "ag-grid-angular";
import { MediaTranscoderRoutes } from "./media-transcoder.routes";
import { MediaTranscoderJobsComponent } from "./jobs/jobs.component";
import { MediaTranscoderJobsActiveComponent } from "./jobs/active/active.component";
import { MediaTranscoderHistoryComponent } from "./jobs/history/history.component";
import { MediaTranscoderJobEditorComponent } from "./jobs/job-editor/job-editor.component";
import { JobSettingsComponent } from "./jobs/job-settings/job-settings.component";
import { MediaFilesLandzoneComponent } from "./jobs/job-settings/media-files-landzone/media-files-landzone.component";
import { PriotiryLevelComponent } from "./jobs/job-settings/priotiry-level/priotiry-level.component";
import { TranscodingJobReportComponent } from "./jobs/history/transcoding-job-report/transcoding-job-report.component";
import { MediaTranscoderPackagerJobsComponent } from "./jobs/packager/packager.component";
import { ShakaPackagerJobReportComponent } from "./jobs/packager/shaka-packager-job-report/shaka-packager-job-report.component";
import { PackagerBulkCreateDialogComponent } from "./jobs/packager/packager-bulk-create-dialog/packager-bulk-create-dialog.component";
import { HistoryBulkRedoDialogComponent } from "./jobs/history/history-bulk-redo-dialog/history-bulk-redo-dialog.component";
import { AngularDraggableModule } from "angular2-draggable";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EvrideoCommonModule,
    BrowserAnimationsModule,
    InlineSVGModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 5000,
    }),
    RouterModule.forRoot(MediaTranscoderRoutes),
    AgGridModule,
    AngularDraggableModule,
  ],
  declarations: [
    MediaTranscoderJobsComponent,
    MediaTranscoderJobsActiveComponent,
    MediaTranscoderHistoryComponent,
    MediaTranscoderJobEditorComponent,
    JobSettingsComponent,
    MediaFilesLandzoneComponent,
    PriotiryLevelComponent,
    TranscodingJobReportComponent,
    MediaTranscoderPackagerJobsComponent,
    ShakaPackagerJobReportComponent,
    PackagerBulkCreateDialogComponent,
    HistoryBulkRedoDialogComponent,
  ],
  providers: [],
  exports: [RouterModule, InlineSVGModule, ToastrModule],
})
export class MediaTranscoderModule {}
